import { Card, Input, CardBody, Button, CardFooter, useSelect, AutocompleteItem, Autocomplete } from "@heroui/react"
import { useState } from "react"
import { ErrorCard, MainContainer } from "../../components"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { apiRoute } from "../../constants/enum"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { useModalToast } from "../../components/modalToast/ModalToastContext"

const AccountSwapping = () => {
    const { user } = useSelector((state) => state.auth)
    const { compCode } = useSelector((state) => state.company);
    const { show } = useModalToast();
    let [formData, setFormData] = useState({
        oldAcId: "",
        newAcId: ""
    })
    const handleAutoCompleteChange = (value, name) => {
        //const { value, name } = e.target;
        setFormData({ ...formData, [name]: value })
    }

    const { data: accountList = [] } = useFetchWithBody({
        url: apiRoute.account.fetchAllAccount,
        queryKey: "fetchAccountList",
        inputData: {
            comp_code: compCode.join(",")
        }

    })
    const downloadTxtFile = (data) => {

        let Title = `Old Account:${formData.oldAcId}  and  New Account:${formData.newAcId}`
        const textContent = data
            .map(
                (item) =>
                    `TableName: ${item.TableName} | ColumnName: ${item.ColumnName} | UpdatedRows: ${item.UpdatedRows} | RecordIDs: ${item.RecordIDs}`
            )
            .join("\n");

        const Text = Title + "\n\n" + textContent
        const blob = new Blob([Text], { type: "text/plain" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Account-Swaping-Logs.txt";
        a.click();

        window.URL.revokeObjectURL(url);
    };
    const { isPending, isError, mutate: funUpdateAcc } = usePost({
        url: apiRoute.account.swapAccount,
        queryKey: "SwapingAccount",
        onSuccessTasks: (data) => {
            
            downloadTxtFile(data)
            toast.success("Account Swapping Success", {
                position: "top-center"
            })
            setFormData({})
        }


    })
    if (isError) {
        return <ErrorCard />
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.oldAcId.trim() == formData.newAcId.trim()) {
            show("Old Account and New Account cannot be the same.")
            return;
        }

        funUpdateAcc({
            data: {
                comp_code: compCode.join(","),
                old_acid: formData.oldAcId,
                new_acid: formData.newAcId
            }
        })

    }
    return (
        <div>
            <MainContainer pageName="Account Swapping" breadcrumbs={[",Master", "Account", "Account Swapping"]}>

                {/* <h2 className="mb-4 text-center font-bold leading-none tracking-tight
                 text-gray-900 md:text-1xl lg:text-xl dark:text-white" >Reset Password</h2> */}
                <div className=" shadow pb-5  min-w-md">
                    <div className="  pb-5 flex flex-col item-center">
                        <form onSubmit={handleSubmit}>

                            <div className="items-center gap-2 px-5 py-5">
                                <Autocomplete
                                    isRequired
                                    size="sm"
                                    radius="sm"
                                    color={"warning"}
                                    name={"oldAcId"}
                                    variant="flat"
                                    eventResizeFeature={true}
                                    selectionMode="single"
                                    showScrollIndicators={true}
                                    placeholder="-Select-"
                                    label="Old Account"
                                    labelPlacement="outside"
                                    className="w-full text-xs font-semibold uppercase"
                                    classNames={{
                                        base: "min-h-[24px]",
                                        title: "text-xs",
                                        input: "text-xs",
                                    }}
                                    menuTrigger={"input"}
                                    isClearable={false}
                                    //isLoading={isLoadingData}
                                    isVirtualized
                                    defaultItems={
                                        accountList || []
                                    }
                                    onSelectionChange={(e) =>
                                        handleAutoCompleteChange(e, "oldAcId")}
                                    selectedKey={formData.oldAcId}
                                >
                                    {(item) => (
                                        <AutocompleteItem
                                            key={item.Party_Id}
                                            classNames={{
                                                base: "min-h-[24px] ",
                                                title: "text-xs whitespace-normal break-words",
                                            }}

                                        >
                                            {` ${item.Party_Name} ( ${item.Party_Id} ) `}
                                        </AutocompleteItem>
                                    )}
                                </Autocomplete>
                            </div>
                            <div className="items-center gap-2 px-5">
                                <Autocomplete
                                    isRequired
                                    size="sm"
                                    radius="sm"
                                    color={"danger"}
                                    name={"newAcId"}
                                    variant="flat"
                                    eventResizeFeature={true}
                                    selectionMode="single"
                                    showScrollIndicators={true}
                                    placeholder="-Select-"
                                    label="New Account"
                                    labelPlacement="outside"
                                    className="w-full text-xs font-semibold uppercase"
                                    classNames={{
                                        base: "min-h-[24px]",
                                        title: "text-xs",
                                        input: "text-xs",
                                    }}
                                    menuTrigger={"input"}
                                    isClearable={false}
                                    //isLoading={isLoadingData}
                                    isVirtualized
                                    defaultItems={
                                        accountList || []
                                    }
                                    onSelectionChange={(e) =>
                                        handleAutoCompleteChange(e, "newAcId")}
                                    selectedKey={formData.newAcId}
                                >
                                    {(item) => (
                                        <AutocompleteItem
                                            key={item.Party_Id}
                                            classNames={{
                                                base: "min-h-[24px] ",
                                                title: "text-xs whitespace-normal break-words",
                                            }}

                                        >
                                            {` ${item.Party_Name} ( ${item.Party_Id} ) `}
                                        </AutocompleteItem>
                                    )}
                                </Autocomplete>
                            </div>
                            <div className="flex justify-center mt-5">
                                <Button color="primary" type="submit" size="sm" isLoading={isPending}
                                    className="bg-slate-700" >
                                    Update Account
                                </Button>
                            </div>


                        </form>


                    </div>
                </div>
            </MainContainer>
        </div>
    )
}
export default AccountSwapping